import getCurrencyDisplayIcon from '@/shared/utils/getDisplayAmount/helpers/getCurrencyDisplayIcon';

const useCurrencyIcon = (currency: string) => {
  const finalCurrency = currency;
  const icon = getCurrencyDisplayIcon(finalCurrency as CashierCurrency, false);
  return icon;
};

export default useCurrencyIcon;
